<template>
  <div class="parking-info-wrapper">
    <div class="parking-info-middle">
      <div class="parking-info-middle-items">
        <span class="parking-info-middle-zone">{{getStateWithParam("AZone")}}</span>
        <span class="parking-info-middle-hour">{{ getStateWithParam("1_hour")}}</span>
        <span class="parking-info-middle-price">{{getStateWithParam("100_price")}}</span>
      </div>
      <div class="parking-info-middle-items">
        <span class="parking-info-middle-zone">{{getStateWithParam("BZone")}}</span>
        <span class="parking-info-middle-hour">{{ getStateWithParam("1_hour")}}</span>
        <span class="parking-info-middle-price">{{getStateWithParam("40_price")}}</span>
      </div>
      <div class="parking-info-middle-items">
        <span class="parking-info-middle-zone">{{getStateWithParam("CZone")}}</span>
        <span class="parking-info-middle-hour">{{ getStateWithParam("1_hour")}}</span>
        <span class="parking-info-middle-price">{{getStateWithParam("20_price")}}</span>
      </div>
    </div>
    <div class="parking-info-bottom">{{getStateWithParam("time_to_park_anouncmant")}}</div>
  </div>
</template>

<script>
export default {
  name: "ParkingInfo",
  data() {
    return {};
  },
  methods: {
    getStateWithParam(param) {
      return this.$store.getters.getLanguageParameters(param);
    }
  }
};
</script>

<style lang="scss" scoped>
.parking-info-wrapper {
  padding: 0 15px 15px 15px;
  .parking-info-middle {
    display: flex;
    font-size: 12px;
    padding-bottom: 15px;
    border-bottom: 1px solid #ededed;
    .parking-info-middle-items {
      flex: 1 auto;
      display: flex;
      align-items: center;
      flex-direction: column;
      line-height: 1.4;
      border-right: 1px solid #ededed;
      &:last-child {
        border-right: 0;
      }
      .parking-info-middle-zone {
        font-weight: 500;
      }
      .parking-info-middle-price {
        font-style: italic;
      }
    }
  }
  .parking-info-bottom {
    font-size: 10px;
    font-weight: 300;
    font-style: italic;
    text-align: center;
    padding-top: 15px;
  }
}
</style>


